import { createAsyncThunk } from '@reduxjs/toolkit'
import apiClient from '../../../services/axois'
import { API_ROUTES } from '../../../utility/api.routes'


export const getResult = createAsyncThunk('result/getAllExam', async (timetableId) => {
    try {
      const url = API_ROUTES.EXAM.GET_RESULT(timetableId)
      const response = await apiClient.get(url)
      return response?.data?.result
    } catch (error) {
      console.error('builder function error:', error)
      throw error
    }
  })
